import common from "./general";
import store2 from 'store2';
import comm from "./communication.api";
// import i18n from "@/i18n"

export default {
  async signup(options) {
    let signed = false;

    let api = "users/signup_new_owner/";

    let msgRes = await common.wBackEndComm.PostData(api, options);

    if (msgRes.data.Status == 1) {
      store2("token", msgRes.data.Body.token);
      store2("username", msgRes.data.Body.username);
      this.onChange(true);
    }
    signed = msgRes.data;
    return signed;
  },
  async login(options) {
    let signed = false;
    let anonymous_profile = this.getProfile(false);

    let api = "users/login/";
    let msgRes = await common.wBackEndComm.PostData(api, options);

    if (msgRes.data.Status == 1) {
      store2("token", msgRes.data.Body.token);
      store2("username", msgRes.data.Body.username);
      store2("menu_int", msgRes.data.Body.menu_int);
      store2("fullname", msgRes.data.Body.fullname);
      store2("hub", msgRes.data.Body.hub);
      store2("appVersion", msgRes.data.Body.appVersion);
      // store2("appVersion", comm.app_version);
      store2("lastLogin", new Date().toISOString());
      // store2("pageView", msgRes.data.Body.pageView);
      // store2("pageID", common.App.update_pageID);

      let temp = {};
      let tt = msgRes.data.Body.username;
      temp[tt] = msgRes.data.Body.profile;
      temp["anonymous"] = anonymous_profile;
      store2("profiles", temp);

      this.onChange(true);
    }

    signed = msgRes.data;
    return signed;
  },
  async setProfile(blSignIn, newProfile) {
    let temp = structuredClone(store2("profiles")) || {}

    if (blSignIn) {
      let keyUsername = this.getUsername();
      temp[keyUsername] = newProfile;

      // Note: proceed to update DB
      let obj = {
        "username": keyUsername,
        "profile": newProfile,
      }
      // NOTE: PutData = update records | PostData = insert new records
			let result = await common.wBackEndComm.PutData("users/emp_profile/", obj);

			if (result.data.Status == 1) {
        common.wMsgBox.Success(result.data.Description);
			} else {
				common.wMsgBox.Error(result.data.Description);
			}

    } else {
      temp["anonymous"] = newProfile;
    }
    store2("profiles", temp);
    // this.$i18n.locale = newProfile.language;
  },
  getProfile(blSignIn) {
    let temp_profiles = structuredClone(store2("profiles"));

    let profile = {
          "theme":0,
          "language":"en",
          "id":0,
          "created_by_id":0,
          "emp_id":0,
          "modified_by_id":0,
          "owner_id":0
        }

    if (blSignIn) {
      profile = temp_profiles[this.getUsername()];
    } else {
      if (!temp_profiles || temp_profiles["anonymous"] == undefined) {
        profile = profile;
        this.setProfile(blSignIn, profile);
      } else {
        profile = temp_profiles["anonymous"]
      }
    }

    return profile;
  },
  getToken() {
    return store2("token");
  },
  getUsername() {
    return store2("username");
  },
  getFullName() {
    return store2("fullname");
  },
  getHub() {
    return store2("hub");
  },
  getMenu() {
    var temp = store2("menu");
    for (var i in temp) {
      var el = temp[i];
      el.component_path = el.component_path
        ? JSON.parse(el.component_path)
        : "";
    }
    return temp;
  },
  getMenu_int() {
    var temp = store2("menu_int");

    // if (!temp) {
    //   temp = [];
    // }
    for (var i in temp) {
      var el = temp[i];
      el.component_path = el.component_path
        ? JSON.parse(el.component_path)
        : "";
    }
    return temp;
  },
  getAppVersion() {
    return store2("appVersion");
  },
  getLastLogin() {
    return store2("lastLogin");
  },
  // getPageView() {
  //   return store2("pageView");
  // },
  logout() {
    // store2(false);
    let temp = this.getProfile(false);
    store2.remove("profiles");
    this.setProfile(false, temp);

    store2.remove("token");
    store2.remove("username");
    store2.remove("fullname");
    store2.remove("hub");
    // store2.remove("pageView");
    store2.remove("menu");
    store2.remove("menu_int");
    store2.remove("appVersion");
    store2.remove("lastLogin");
    store2.remove("darkMode");
    this.onChange(false);
  },
  loggedIn() {
    return !!store2("token");
  },
  onChange(blSignIn) {
    return blSignIn;
  },
  hideHeader(action) {
    return action;
  },
  hideFooter(action) {
    return action;
  },
  async refreshMenu() {
    let api = "users/api_refreshMenu/";
    let msgRes = await common.wBackEndComm.PostData(api);
    if (msgRes.data.Status == 1) {
      store2("menu_int", msgRes.data.Body.menu_int);
      store2("menu", msgRes.data.Body.menu);
      store2("appVersion", msgRes.data.Body.appVersion);
    }

    // let api = "users/get_menu_int/";
    // let msgRes = await common.wBackEndComm.PostData(api);
    // if (msgRes.data.Status == 1) {
    //   store2("menu_int", msgRes.data.Body);
    // }

    // api = "users/get_menu/";
    // msgRes = await common.wBackEndComm.PostData(api);
    // if (msgRes.data.Status == 1) {
    //   store2("menu", msgRes.data.Body);
    // }

    // api = "api_get_app_version";
    // msgRes = await common.wBackEndComm.GetData(api);
    // if (msgRes.data.Status == 1) {
    //   store2("appVersion", msgRes.data.Body);
    // }

    // store2("appVersion", comm.app_version);
    store2("lastLogin", new Date().toISOString());
    window.location.reload();

      // if (this.getMenu().length == 0) {
      //   console.log(this.getMenu().length);
      //   this.onChange(false);
      //   store2("menu", msgRes.data.Body.menu);
      // }

      // this.onChange(true);

  },
};